import Input from '../../../ui/input';
import Text from '../../../ui/text';
import { useFormContext } from "react-hook-form";
import { useTranslation } from 'react-i18next';

function PersonalContact() {
  const { t } = useTranslation();
  const { 
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <section className="w-full">
      <h2 className="text-2xl font-semibold opacity-[var(--sds-size-stroke-border)] text-sky-950">
        <Text>Your Personal Contact</Text>
      </h2>
      <div className="grid grid-cols-12 gap-5 mt-5">
        <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='mainPhoneNumber'>Main Phone Number *</Text>
          <Input
            {...register('mainPhoneNumber')}
            size='sm'
            label={<Text>Main Phone Number</Text>}
            placeholder={t('0123456789')}
            errorMessage={errors?.mainPhoneNumber?.message || null}
            isInvalid={errors?.mainPhoneNumber ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='alternatePhoneNumber'>Alternate Phone Number</Text>
          <Input
            {...register('alternatePhoneNumber')}
            size='sm'
            label={<Text>Alternate Phone Number</Text>}
            placeholder={t('0123456789')}
            errorMessage={errors?.alternatePhoneNumber?.message || null}
            isInvalid={errors?.alternatePhoneNumber ? true : false}
          />
        </div>
      </div>
    </section>
  );
}

export default PersonalContact;
